import { styled } from '@clickcease/cc-client-components-lib'

export const SignupTitle = styled('div', {
  color: '$black',
  fontWeight: '700',
  fontSize: '$hxl',
  textAlign: 'center',

  '@bp1': {
    fontSize: '$h2',
  },

  variants: {
    marginBottom: {
      true: {
        marginBottom: '$20',
      },
    },
  },
})

export const CheqEssentials = styled('span', {
  color: '$primaryColor',
})

export const SignupSlogan = styled('div', {
  color: '$cheqTextColor',
  fontWeight: '$l',
  fontSize: '$lg',
  textAlign: 'center',
  marginBottom: '$20',
  marginTop: '$4',
})

export const SignupSloganNew = styled('div', {
  color: '$cheqTextColor',
  textAlign: 'center',
  marginBottom: '$20',
  marginTop: '$4',
  fontSize: '$h1',
  fontWeight: '$l',

  '@bp1': {
    width: '70%',
    fontSize: '$h4',
  },
})

export const TermsAndConditions = styled('div', {
  marginTop: '12px',
  fontWeight: '$l',
  textAlign: 'center',
  position: 'relative',

  '@bp1': {
    width: '88%',
  },
})

export const PasswordWrapper = styled('div', {
  position: 'relative',

  '@bp1': {
    width: '100%',
  },
})
export const SignUpErrorWrapper = styled('div', {
  margin: '10px 0',
  padding: '0 44px',
})

export const SignUpErrorWrapperSmall = styled('div', {
  height: '10px',
  marginBottom: '10px',
})

export const SignUpError = styled('span', {
  fontWeight: '$r',
  fontSize: '$md',
  color: '$error',
})

export const SignUpErrorSmall = styled('span', {
  fontWeight: '$r',
  fontSize: '$sm',
  color: '$error',
})

export const AlreadyACustomer = styled('div', {
  color: '$cheqTextColor',
  fontWeight: '$l',
  textAlign: 'center',
})

export const Link = styled('a', {
  color: '$primaryColor',
  margin: '0px 5px',
  fontWeight: '$b',
  textDecoration: 'none',

  '@bp1': {
    display: 'block',
  },
})

export const LoginLink = styled('span', {
  color: '$primaryColor',
  margin: '0px 5px',
  fontWeight: '$b',
  cursor: 'pointer',
})
